import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import App from './App';
import theme from './theme';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://29d6684206f24f6eb8711f85c599263a@o4505067714969600.ingest.sentry.io/4505067933925376",
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// ReactDOM.render(
//     <div
//         style={{
//             position: 'absolute', left: '50%', top: '50%',
//             transform: 'translate(-50%, -50%)'
//         }}
//     >
//         Hello, world!
//     </div>,
//     document.getElementById('root')
// );

ReactDOM.render(
    <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <App />
  </ThemeProvider>,
  document.querySelector('#root'),
);
